<template>
  <div>
    <h2 class="orderWorkersPopUp__title">Назначить сотрудников</h2>
    <div class="popup-content">
      <div class="orderWorkersPopupContent">
        <Workers :workers="workers" isPopUp @updateCheckedItems="updateCheckedItems" :orderWorkers="orderWorkers" />
        <div class="orderWorkersPopUp__actions">
          <v-btn depressed color="primary" x-large width="60%" @click="handleSaveClick">Сохранить</v-btn>
          <v-btn x-large width="40%" @click="$emit('handleCloseWorkersPopUp')">Отмена</v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { ref, computed } from '@vue/composition-api'
import useRequest from '@/compositions/useRequest'
import Workers from '../Workers/Workers'


export default {
  components: {
    Workers,
  },
  props: {
    workers: Array,
    orderId: Number,
    orderWorkers: Array,
  },
  setup(props, context) {
    const { $store } = context.root
    const { emit } = context
    const data = ref({})
    const company = computed(() => $store.getters['auth/user'])

    const updateCheckedItems = (newData) => {
      data.value = { employee_ids: newData, company_id: company.value.companyId }
    }
    const workerRequest = useRequest({
      context,
      request: () => $store.dispatch('orders/postWorkers', { orderId: props.orderId, data: data.value }),
    })
    const orderRequest = useRequest({
      context,
      request: id => $store.dispatch('orders/fetchOrder', { id }),
    })
    const handleSaveClick = async () => {
      await workerRequest.makeRequest()
      const response = await orderRequest.makeRequest(props.orderId)
      emit('handleCloseWorkersPopUp')
      emit('updateOrderData', response)
    }
    return {
      updateCheckedItems,
      handleSaveClick,
    }
  },
}
</script>

<style lang="scss">
.orderWorkersPopUp__title {
  color: #222;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.32px;
}

.orderWorkersPopUp__actions {
  display: flex;
  gap: 10px;
}

.orderWorkersPopupContent {
  height: 78vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>
